import ThreadAlertBaseModel from './ThreadAlertBaseModel'

class ThreadMentionAlertModel extends ThreadAlertBaseModel<
  'mention-in-activity-comment',
  { activityId: string; commentId: string; conversationId: string; userId: string }
> {}

export default ThreadMentionAlertModel
